import { render, staticRenderFns } from "./DetailsContattoAzienda.vue?vue&type=template&id=79485932&scoped=true&"
import script from "./DetailsContattoAzienda.vue?vue&type=script&lang=ts&"
export * from "./DetailsContattoAzienda.vue?vue&type=script&lang=ts&"
import style0 from "./DetailsContattoAzienda.vue?vue&type=style&index=0&id=79485932&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79485932",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCardText,VCol,VRow})
